import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 bg-clinical-base" data-id="element-149">
      <div className="max-w-[800px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-6 md:p-12 border border-clinical-line text-center" data-id="element-151">
          <div className="w-14 h-14 md:w-20 md:h-20 mx-auto bg-clinical-soft rounded-full flex items-center justify-center mb-5" data-id="element-152">
            <ShieldCheck className="w-7 h-7 md:w-10 md:h-10 text-clinical-mid" strokeWidth={2} data-id="element-153" />
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-clinical-deep mb-5 leading-tight uppercase" data-id="element-154">
            Garantía 7 días <br className="md:hidden" data-id="element-155" />
            <span className="accent-italic normal-case" data-id="element-156">sin preguntas</span>
          </h2>

          <div className="text-base md:text-lg text-clinical-ink space-y-3 mb-6" data-id="element-157">
            <p data-id="element-158">
              Abrís los tomos. Los usás para estudiar, repasar o preparar tus
              prácticas.
            </p>
            <p data-id="element-159">Si en 7 días no era lo que esperabas:</p>
            <ul className="font-semibold text-clinical-deep space-y-1.5 inline-block text-left" data-id="element-160">
              <li data-id="element-161">
                · devolución del <span className="accent-italic" data-id="element-162">100%</span>
              </li>
              <li data-id="element-163">· sin formularios raros, sin vueltas, sin drama.</li>
            </ul>
          </div>

          <div className="inline-block px-4 py-2 bg-clinical-base border border-clinical-line rounded-full text-clinical-deep font-semibold text-xs md:text-sm" data-id="element-164">
            Tasa de devoluciones: menos del 1%
          </div>
        </motion.div>
      </div>
    </section>;
}